import { FC, useState } from 'react';

import { Flex, Segmented, Spin } from 'antd';
import { useParams } from 'react-router-dom';

import { AccessDenied, TransactionBatches, TransactionsContent } from '@entities';
import { useBackofficeTransactionsAccess } from '@hooks';

import * as S from './styled';

type TransactionsView = 'transactions' | 'batches';

const Transactions: FC = () => {
  const { companyId } = useParams<{ companyId: string }>();
  const { canView, isLoading } = useBackofficeTransactionsAccess({ companyId });
  const [view, setView] = useState<TransactionsView>('transactions');

  if (isLoading) return <Spin />;
  if (!canView) return <AccessDenied />;

  return (
    <Flex gap={24} vertical>
      <Flex align="center" justify="space-between" gap={16} wrap="wrap">
        <S.PageTitle>Transactions</S.PageTitle>

        <Segmented<TransactionsView>
          value={view}
          onChange={setView}
          options={[
            { label: 'Transactions', value: 'transactions' },
            { label: 'Uploaded batches', value: 'batches' },
          ]}
        />
      </Flex>

      {view === 'transactions' ? (
        <TransactionsContent />
      ) : (
        <TransactionBatches companyId={companyId} />
      )}
    </Flex>
  );
};

export default Transactions;
